import React from 'react';

import { ConfigProvider } from 'antd';

// Apollo
import { ApolloProvider } from '@apollo/react-hooks';
import { client, publicClient  } from 'shared/services/ApolloClient';

import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';

import frFR from 'antd/es/locale/fr_FR';

import 'antd/dist/antd.css';
import './App.scss';

// Router
import ProtectedRoute from 'shared/components/ProtectedRoute';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { AuthProvider } from 'shared/contexts/AuthContext';

// Views
import Layout from 'views/Layout';
import LayoutMobile from 'mobile/views/Layout';
import Login from 'views/login/Login';
import ResetPassword from 'shared/components/ResetPassword';
import ResetPasswordRequest from 'shared/components/ResetPasswordRequest';
import MenuClient from 'shared/components/MenuClient';
import MenuClientMobile from 'shared/components/MenuClientMobile';
import MenuClientUsed from 'shared/components/MenuClientUsed';
import MenuClientUsedMobile from 'shared/components/MenuClientUsedMobile';
import MenuClientValide from 'shared/components/MenuClientValide';
import MenuClientValideMobile from 'shared/components/MenuClientValideMobile';

import ErrorBoundary from 'shared/components/ErrorBoundary';

// moment
import moment from 'moment';
import 'moment/locale/fr';
import {useMedia} from "react-use";
moment.locale('fr');

export default function App() {
    const isMobile = useMedia('(max-width: 800px)');
    return (
        <ErrorBoundary>
            <DndProvider backend={HTML5Backend}>
                <ApolloProvider client={client}>
                    <ConfigProvider locale={frFR}>
                        <AuthProvider>
                            <Router>
                                <Switch>
                                    <Route
                                        exact
                                        path="/login"
                                        component={Login}
                                    />
                                    <Route
                                        exact
                                        path="/reset-password"
                                        component={ResetPassword}
                                    />
                                    <Route
                                        exact
                                        path="/reset-password-request"
                                        component={ResetPasswordRequest}
                                    />
                                    <Route
                                        exact
                                        path="/menu-client"
                                        render={() => (
                                            <ApolloProvider client={publicClient}>
                                                {isMobile ? <MenuClientMobile /> : <MenuClient />}
                                            </ApolloProvider>
                                        )}
                                    />
                                    <Route
                                        exact
                                        path="/menu-client-valide"
                                        render={() => (
                                            <ApolloProvider client={publicClient}>
                                                {isMobile ? <MenuClientValideMobile /> : <MenuClientValide />}
                                            </ApolloProvider>
                                        )}
                                    />
                                    <Route
                                        exact
                                        path="/menu-client-used"
                                        render={() => (
                                            <ApolloProvider client={publicClient}>
                                                 <MenuClientUsed />
                                            </ApolloProvider>
                                        )}
                                    />

                                    {!isMobile ? (
                                    <ProtectedRoute
                                        path="/"
                                        component={Layout}
                                    />
                                     ) : (
                                    <ProtectedRoute
                                        path="/"
                                        component={LayoutMobile}
                                    />
                                     )}
                                </Switch>
                            </Router>
                        </AuthProvider>
                    </ConfigProvider>
                </ApolloProvider>
            </DndProvider>
        </ErrorBoundary>
    );
}
